<template>
  <div v-if="isHorizontalPadOrMore" class="ml-auto flex w-fit">
    <a
      v-for="item in icons"
      :key="item"
      v-bind="hasMaterials(item)?.has_content && { href: getHref(item) }"
      class="materials tooltip mr-2 grid size-8 place-content-center rounded-full transition"
      :class="[
        hasMaterials(item)?.has_content
          ? 'has-materials hover-item'
          : 'hover-item  cursor-default',
      ]"
      @click.prevent="handleRouteSlug(item)"
    >
      <SvgIcon
        class="materials-icon size-4"
        :name="`teacher/${item}`"
      ></SvgIcon>
      <span v-if="hasMaterials(item)" class="tooltiptext"
        >{{ hasMaterials(item)?.name }}
      </span>
    </a>
  </div>
  <div
    v-else
    class="materials hover-item not-shadow group relative ml-auto grid size-8 min-w-[32px] max-w-[32px] place-content-center rounded-full transition hover:bg-[#a100090f]"
    @click.prevent="showPopup"
  >
    <SvgIcon
      class="materials-icon size-4 transition group-hover:text-collection"
      :name="`teacher/info`"
    >
    </SvgIcon>
    <div
      v-if="isShow"
      ref="contentRef"
      class="absolute bottom-0 left-0 size-fit -translate-x-full translate-y-full rounded-md bg-black-56/[0.68] px-3 py-2"
    >
      <NuxtLink
        v-for="item in contentTypes"
        :key="item.model"
        v-bind="
          hasMaterials(item.model)?.has_content && { to: getHref(item.model) }
        "
        class="mb-2 flex items-center whitespace-nowrap text-[16px] font-semibold uppercase leading-[18px] text-white-100 last:mb-0"
      >
        {{ item.name }}: {{ item.count }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  icons: {
    type: Array,
    default: () => [],
  },
  highlight: {
    type: Object,
    default: () => ({}),
  },
  segment: {
    type: String,
    required: true,
  },
});

const { isHorizontalPadOrMore } = useBreakpoint();
const route = useRoute();
const router = useRouter();
const contentRef = ref(null);
const isShow = ref(false);

const contentTypes = computed(() => {
  const content = {
    teacher: [
      'article',
      'videomaterial',
      'audiomaterial',
      'test',
      'wiki',
      'book',
      'date',
      // 'presentation',
    ],
    destination: ['region_route', 'region_article', 'region_heraldic'],
  };
  return props.highlight?.content_types?.filter(({ model }) =>
    content[props.segment].includes(model),
  );
});
const getHref = (item) => {
  return `/${props.segment}${
    props.segment !== 'teacher' ? '' : `/${route?.params?.parent}`
  }/${props.highlight.slug}?content=${item}`;
};
const hasMaterials = (icon) => {
  const content = props.highlight.content_types.find(
    (type) => type.model === icon,
  );

  if (!content) return;

  return {
    count: content.count,
    name: content.name,
    has_content: content?.count,
  };
};
const showPopup = () => {
  isShow.value = true;
};
const closePopup = () => {
  isShow.value = false;
};
const handleRouteSlug = (item) => {
  if (!hasMaterials(item)?.has_content) return;
  router.push(getHref(item));
};
onClickOutside(contentRef, () => {
  closePopup();
});
</script>
